import { ConfigurationContextValue } from '@app/root/ConfigurationContext';
import { MissionLight } from '@wwf/sdk';

export type MissionByStatus = Record<MissionLight['status'], MissionLight[]>;

export const getMissionByStatus = (
    unorderedMission: MissionLight[],
    missionStatusLabels: ConfigurationContextValue['missionStatusLabels']
): MissionByStatus => {
    if (!missionStatusLabels) return {} as MissionByStatus;
    const missionByStatus: MissionByStatus = unorderedMission.reduce(
        (acc, mission) => {
            acc[mission.status].push(mission);
            return acc;
        },
        missionStatusLabels.reduce(
            (obj, status) => ({ ...obj, [status.value]: [] }),
            {} as Record<MissionLight['status'], MissionLight[]>
        )
    );
    return missionByStatus;
};
